import { useAskComputerCommandMenu } from '#pplx/frontend/apps/ask/composer-sdk-plugins/computer-command-menu/useAskComputerCommandMenu.js';
import { useSearchModeTypeaheadPlugin } from '#pplx/frontend/apps/ask/composer-sdk-plugins/search-mode-typeahead/useSearchModeTypeaheadPlugin.js';
import { useSelectedSearchMode } from '#pplx/frontend/apps/ask/hooks/selected-search-mode-hooks/useSelectedSearchMode.js';
import { useComputerCommandMenuMentionTypeahead } from '#pplx/frontend/apps/ask/mention-typeahead/useMentionTypeaheadOptions.js';
import { SearchMode } from '#pplx/frontend/ask-models/types/search-modes.js';
import { useMentionTypeaheadPlugin } from '#pplx/frontend/composer-sdk-plugins/mention-typeahead/useMentionTypeaheadPlugin.js';
import { useMemo } from 'react';
/** Reuses Home mention eligibility and the shared Computer/Search slash providers. */
export function useHomeComposerComputerMenuPlugins({ reason, onSearchModeSelected, searchModeControls, omitDeviceMentions, }) {
    const selectedSearchMode = useSelectedSearchMode();
    const showComputerCommandMenu = selectedSearchMode === SearchMode.ASI && searchModeControls.enabled;
    const { computerCommandMenuOpen, mentionIconRenderer, mentionTypeaheadContext, mentionTypeaheadOptions, onComputerCommandMenuOpenChange, onTriggerTypeahead, } = useComputerCommandMenuMentionTypeahead({
        reason,
        isLazy: true,
        omitDeviceMentions,
    });
    const computerCommandMenu = useAskComputerCommandMenu({
        computerCommandMenuOpen,
        enabled: showComputerCommandMenu,
        isFollowUp: false,
        onComputerCommandMenuOpenChange,
        onSearchModeSelected,
        overlayPlacement: 'below',
        searchModeControls,
    });
    const { plugins: mentionPlugins } = useMentionTypeaheadPlugin({
        mentionTypeaheadContext,
        mentionTypeaheadOptions,
        mentionIconRenderer,
        onTriggerTypeahead,
        // Computer and Search use their dedicated slash providers, as on the thread.
        includeSlashProviders: false,
    });
    const searchModeTypeaheadPlugin = useSearchModeTypeaheadPlugin({
        omittedSearchModes: searchModeControls.omittedModes,
        onSearchModeSelected,
        separateComputerMode: true,
    });
    const plugins = useMemo(() => [...mentionPlugins, ...computerCommandMenu.plugins], [computerCommandMenu.plugins, mentionPlugins]);
    const suggestionPlugins = useMemo(() => searchModeControls.enabled && !showComputerCommandMenu ? [searchModeTypeaheadPlugin] : [], [searchModeControls.enabled, searchModeTypeaheadPlugin, showComputerCommandMenu]);
    return useMemo(() => ({
        plugins,
        suggestionPlugins,
        typeahead: computerCommandMenu.typeahead,
        isComputerCommandMenuOpen: showComputerCommandMenu && computerCommandMenuOpen,
    }), [
        computerCommandMenu.typeahead,
        computerCommandMenuOpen,
        plugins,
        showComputerCommandMenu,
        suggestionPlugins,
    ]);
}
//# sourceMappingURL=useHomeComposerComputerMenuPlugins.js.map